import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "./plugins/vant"
import 'vant/lib/index.css';
import cookie from 'js-cookie'; // cookie
import config from './config';
import axios from 'axios'; //请求管理器
import store from './vuex/store'; // vuex store

// 转换rem
import "./rem.js"

// 动画效果
import animate from 'animate.css'
Vue.use(animate)

// 自定义全局css样式
import './assets/css/global.css'
import './assets/css/swiper.css';

import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { default global options } */)
// import
Vue.config.productionTip = false

import util from './assets/js/utils.js'; // 公共方法

Vue.use(util)

//加入原形 api
import api from './api/api.js'; // 引入 api
Vue.prototype.$api = api;
Vue.prototype.$axios = axios;
Vue.prototype.$cookie = cookie;
Vue.prototype.$config = config;

// 单页滚动
import 'animate.css'

// 高德地图
// import VueAMap from 'vue-amap'
// Vue.use(VueAMap)


// VueAMap.initAMapApiLoader({
//   key: 'd4332e5adb8b584442266763d20b978c',
//   plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation'],
//   v: '1.4.4'
// })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
